import styled from 'styled-components';

const Wrap = styled.aside`
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 14px;
  padding: 1rem;
  background: ${({ theme }) => theme.colors.gray050};
  display: grid;
  gap: 0.65rem;
  position: sticky;
  top: 88px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: baseline;
`;

const Label = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.gray700};
`;

const Value = styled.p`
  margin: 0;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray900};
`;

const CTA = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  border-radius: 10px;
  padding: 0.65rem 0.8rem;
  font-weight: 700;
  cursor: pointer;
`;

type CartSummaryProps = {
  readonly itemCount: number;
  readonly primaryServiceCount: number;
  readonly onOpenCart: () => void;
};

export default function CartSummary({
  itemCount,
  primaryServiceCount,
  onOpenCart,
}: CartSummaryProps) {
  const hasBundle = primaryServiceCount >= 2;

  return (
    <Wrap>
      <h3 style={{ margin: 0 }}>Cart Summary</h3>
      <Row>
        <Label>Selected items</Label>
        <Value>{itemCount}</Value>
      </Row>
      <Row>
        <Label>Bundle discount</Label>
        <Value>{hasBundle ? 'Unlocked (15%)' : 'Add 2+ services'}</Value>
      </Row>
      <Label style={{ fontSize: '0.82rem' }}>
        Pricing stays hidden in-cart and is revealed after lead capture in checkout.
      </Label>
      <CTA type="button" onClick={onOpenCart}>
        Open cart
      </CTA>
    </Wrap>
  );
}
